<template>
  <div>
    <a-dialog v-model="widgetDialog" scrollable persistent max-width="600px">
      <v-card class="d-flex" elevation="0">
        <v-toolbar dense color="primaryLight1">
          <v-icon left>mdi-application-cog</v-icon>
          <span>{{ $t("widget.widgetSettings") }}</span>
          <v-spacer></v-spacer>
          <CloseIcon :right="true" @click="$emit('input', false)" />
        </v-toolbar>
        <v-card-text style="position: relative; padding: 5px 20px">
          <v-list
            dense
            v-if="getWidgets.length > 0"
            id="listId"
            style="padding: 0"
          >
            <WidgetList
              v-for="widget in getWidgets"
              :key="widget.id"
              :preconfigured="preconfigured"
              :widget="widget"
              @alert="onAlertMessage"
              @overlay="setOverlay"
            ></WidgetList>
          </v-list>
          <div v-else class="text-center mt-6 mb-3">
            <span>{{ $t("widget.notFoundData") }} !!</span>
          </div>

          <Loader :loading="pOverlay" :message="$t('SaveLoader')"></Loader>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                v-bind="attrs"
                v-on="on"
                color="primaryDark"
                @click="CreateWidgetDialog = true"
                v-if="$security.checkUserAccess('CreateDashboard')"
              >
                {{ $t("widget.createNew") }}
              </a-btn>
            </template>
            <span>{{ $t("widget.createNew") }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                class="ml-2"
                v-bind="attrs"
                v-on="on"
                color="secondary"
                @click="$emit('input', false)"
              >
                {{ $t("widget.close") }}
              </a-btn>
            </template>
            <span>{{ $t("widget.close") }}</span>
          </v-tooltip>
        </v-card-actions>
        <create-widget
          v-if="CreateWidgetDialog"
          v-model="CreateWidgetDialog"
          :preconfigured="preconfigured"
          @close="closeCreateWidget"
          @alert="onAlertMessage"
        ></create-widget>
      </v-card>
    </a-dialog>
    <message-sheet
      :showMessage="displayMessage"
      :message="message"
      :messageType="messageType"
      @close="displayMessage = false"
    ></message-sheet>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import WidgetList from "/src/components/widget/WidgetList.vue";
import CreateWidget from "/src/components/widget/CreateWidget.vue";
import MessageSheet from "../MessageSheet.vue";
import Loader from "../Loader.vue";
import ADialog from "../../wrapper-component/ADialog.vue";
import ABtn from "../../wrapper-component/ABtn.vue";
export default {
  name: "WidgetConfiguration",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    WidgetList,
    CreateWidget,
    MessageSheet,
    Loader,
    ADialog,
    ABtn,
  },
  data() {
    return {
      CreateWidgetDialog: false,
      displayMessage: false,
      messageType: "",
      message: "",
      widgets: [],
      pOverlay: false,
    };
  },
  computed: {
    ...mapGetters({
      getWidgets: "widget/dashboardWidgets",
      getDisableWidgets: "widget/getDisableWidgets",
    }),
    widgetDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    preconfigured() {
      const prewidget = [];
      this.getWidgets.filter((data) => {
        if (data.isDynamicContent == 1) {
          return prewidget.push(data.widgetType);
        }
      });
      return prewidget;
    },
  },
  watch: {
    pOverlay(value) {
      value == true &&
        setTimeout(() => {
          this.pOverlay = false;
        }, 1500);
    },
    widgetDialog(value) {
      if (value) {
        setTimeout(() => {
          this.scrollToTop();
        }, 0);
      }
    },
  },
  methods: {
    scrollToTop() {
      if (document.getElementById("listId")) {
        document.getElementById("listId").scrollIntoView({
          behavior: "instant",
          block: "start",
        });
      }
    },
    closeCreateWidget() {
      this.CreateWidgetDialog = false;
    },
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
    onAlertMessage: function (message, MessageType) {
      this.showMessageSheet(message, MessageType);
    },
    setOverlay(value) {
      this.pOverlay = true;
    },
  },
};
</script>